import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import './index.css';
import useBlogs from '../Utils/useBlogs';

function Blogs() {
    const imgCDNURL = "https://prod-cdn.swmc.com/";
    const { blogPosts, loading, error } = useBlogs({ type: 'GET_ALL_BLOGS' });
    // console.log("blogs array: ", blogPosts);

    // Helper function to format blog title for URL
    const formatTitleForURL = (title) => {
        return title
            .replace(/\s+/g, '-') // Replace spaces with hyphens
            .replace(/[^\w\-]/g, ''); // Remove special characters except hyphens
    };

    // Helper function to truncate blog title
    const truncateTitle = (title, length = 90) => {
        return title.length > length ? title.substring(0, length) + '...' : title;
    };

    let dateOptions = { month: "numeric", day: "numeric", year: "numeric" };

    return (
        <section className="Blogs-section">
            <Container className="Blogs-container">
                <h2 className="Blogs-heading">Your Resource Connection</h2>
                <p className="Blogs-para">Get the latest news in the industry</p>

                {blogPosts ? (
                    <Row className="blog-box">
                        {blogPosts.slice(0, 3).map((post, index) => (
                            <Col key={index} md={12} lg={4} className="d-flex align-items-center">
                                <Card className="blog-card">
                                    <Card.Img
                                        variant="top"
                                        src={`${imgCDNURL}blog/${post.img_name}`}
                                        className="blogs-image img-fluid"
                                        alt={`${post.title} - Image`}
                                    />
                                    <Card.Body className="p-1">
                                        <p className="blog-date mb-1">
                                            {new Date(post.date).toLocaleString("en-US", dateOptions)}
                                        </p>
                                        <Card.Text className="blog-title" style={{ maxHeight: '50%' }}>
                                            {truncateTitle(post.title
                                                .replace("â€œ", '"')
                                                .replace("â€", '"')
                                                .replace("â€™", "'")
                                                .replace("â€“", "-")
                                            )}
                                        </Card.Text>
                                    </Card.Body>
                                    <Button
                                        className="post-link"
                                        href={`https://www.swmc.com/blog/${post.tag}/${formatTitleForURL(post.title)}-${post.id}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Read More
                                    </Button>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                ) : (
                    <div className="text-center">
                    <Spinner />
                    <p style={{color: '#FFF'}}>Loading Latest Blogs...</p>
                    </div>
                )}
                <div className='d-flex justify-content-center'>
                    <Button
                        className="blog-button"
                        href="https://www.swmc.com/blog/"
                        target="_blank"
                        rel="noopener noreferrer"
                        variant="warning"
                    >
                        Read More
                    </Button>
                </div>
            </Container>
        </section>
    );
}

export default Blogs;
